import { faLightbulbDollar } from '@fortawesome/pro-light-svg-icons'
import {
  ResidentialCondoOwnershipDetails,
  ResidentialFreeholdOwnershipDetails,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import { DetailsTableRow } from '@unreserved-frontend-v2/ui/details-table/models'
import { currency } from '@unreserved-frontend-v2/utils/currency'
import { emptyDefault } from '@unreserved-frontend-v2/utils/empty-default'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'

export const useEstimatedExpensesRow = (
  details?: ResidentialCondoOwnershipDetails | ResidentialFreeholdOwnershipDetails | null
): DetailsTableRow | undefined => {
  const { t } = useTranslation()
  return useMemo(() => {
    const values = [
      {
        label: t('listings:details-pages.hydro'),
        value: emptyDefault(currency(details?.estimatedMonthlyHydroExpense?.amount)),
      },
      {
        label: t('listings:details-pages.heating'),
        value: emptyDefault(currency(details?.estimatedMonthlyHeatingExpense?.amount)),
      },
      {
        label: t('listings:details-pages.garbage'),
        value: emptyDefault(currency(details?.estimatedMonthlyGarbageExpense?.amount)),
      },
      {
        label: t('listings:details-pages.insurance'),
        value: emptyDefault(currency(details?.estimatedMonthlyInsuranceExpense?.amount)),
      },
      {
        label: t('listings:details-pages.lawn'),
        value: emptyDefault(currency(details?.estimatedMonthlyLawnExpense?.amount)),
      },
      {
        label: t('listings:details-pages.maintenance'),
        value: emptyDefault(currency(details?.estimatedMonthlyMaintenanceExpense?.amount)),
      },
      {
        label: t('listings:details-pages.management'),
        value: emptyDefault(currency(details?.estimatedMonthlyManagementExpenses?.amount)),
      },
      {
        label: t('listings:details-pages.rental-income'),
        value: emptyDefault(currency(details?.estimatedMonthlyRentalIncome?.amount)),
      },
      {
        label: t('listings:details-pages.parking'),
        value: emptyDefault(currency(details?.estimatedMonthlyParkingExpense?.amount)),
      },
      {
        label: t('listings:details-pages.rental-equipment'),
        value: emptyDefault(currency(details?.estimatedMonthlyRentalEquipmentExpense?.amount)),
      },
      {
        label: t('listings:details-pages.security'),
        value: emptyDefault(currency(details?.estimatedMonthlySecurityExpense?.amount)),
      },
      {
        label: t('listings:details-pages.storage'),
        value: emptyDefault(currency(details?.estimatedMonthlyStorageExpense?.amount)),
      },
      {
        label: t('listings:details-pages.water-sewer'),
        value: emptyDefault(currency(details?.estimatedMonthlyWaterSewerExpense?.amount)),
      },
    ]

    const nonEmptyRows = values.filter((item) => item.value !== '-')

    if (!nonEmptyRows.length) {
      return
    }

    return {
      icon: faLightbulbDollar,
      title: t('listings:details-pages.estimated-expenses'),
      cells: [
        {
          id: 'expenses',
          cellClassName: 'col-span-4 md:col-span-4 md:border-l-0',
          data: [
            {
              id: 'data-expenses',
              type: 'table',
              values: nonEmptyRows,
            },
          ],
        },
      ],
    }
  }, [details, t])
}
